(() => {
 if(customElements.get('ms-cart-content')) return;
 let previousRewards,previousCount=0;
 class MaxSmileCart extends HTMLElement {
  connectedCallback(){
   this.addEventListener('click',this.onClick);this.addEventListener('submit',this.onCoupon);
   const count=Number(this.dataset.count)||0;
   const rewards=new Set(JSON.parse(this.dataset.discounts||'[]'));
   if(count>0)rewards.add('milestone:first-item');
   if(count>0 && Number(this.dataset.total)>=30000)rewards.add('milestone:free-shipping');
   const newlyEarned=previousRewards && count>=previousCount && [...rewards].some(reward=>!previousRewards.has(reward));
   previousRewards=rewards;previousCount=count;
   if(newlyEarned)queueMicrotask(()=>{if(this.isConnected)this.celebrate(this.closest('cart-drawer'));});
  }
  disconnectedCallback(){this.removeEventListener('click',this.onClick);this.removeEventListener('submit',this.onCoupon);}
  celebrate(drawer){
   if(!drawer || matchMedia('(prefers-reduced-motion: reduce)').matches)return;
   if(drawer._lastCelebration && Date.now()-drawer._lastCelebration<500)return;
   drawer._lastCelebration=Date.now();
   drawer.querySelector('.ms-cart-confetti')?.remove();
   const layer=document.createElement('div');layer.className='ms-cart-confetti';layer.setAttribute('aria-hidden','true');
   const colors=['#ca0914','#f4bd45','#ffffff','#e86f76','#252525'];
   for(let i=0;i<76;i++){
    const piece=document.createElement('i');const side=i%2;
    piece.style.cssText=`left:${side?92:8}%;top:42%;background:${colors[i%colors.length]};width:${5+Math.random()*6}px;height:${9+Math.random()*9}px;border-radius:${i%5===0?'50%':'1px'};`;
    layer.append(piece);
    const x=(side?-1:1)*(40+Math.random()*310),rise=100+Math.random()*210;
    piece.animate([{transform:'translate(0,0) rotate(0deg)',opacity:1},{transform:`translate(${x*.65}px,${-rise}px) rotate(${180+i*13}deg)`,opacity:1,offset:.3},{opacity:1,offset:.8},{transform:`translate(${x}px,${220+Math.random()*220}px) rotate(${540+i*17}deg)`,opacity:0}],{duration:3500+Math.random()*900,delay:Math.random()*300,easing:'cubic-bezier(.18,.65,.4,1)',fill:'both'});
   }
   drawer.querySelector('.modal-inner').append(layer);setTimeout(()=>layer.remove(),4900);
  }
  onCoupon = async (event) => {
   const form=event.target.closest('[data-coupon-form]');if(!form)return;
   event.preventDefault();if(this.busy)return;
   const input=form.elements.coupon;const code=input.value.trim().toUpperCase();const status=form.querySelector('[data-coupon-status]');
   const say=message=>{status.textContent=message;status.hidden=false;};
   if(!code){say(form.dataset.required);input.focus();return;}
   const save=()=>{document.cookie='discount_code='+encodeURIComponent(code)+';path=/;max-age=14400;SameSite=Lax;Secure';};
   if(['UPI','CRED','CREDITCARD','NETBANKING'].includes(code)){save();say(form.dataset.saved);return;}
   this.busy=true;this.querySelectorAll('button').forEach(b=>b.disabled=true);
   const drawer=this.closest('cart-drawer');const root=window.Shopify?.routes?.root || '/';
   try {
    const beforeResponse=await fetch(root+'cart.js');if(!beforeResponse.ok)throw new Error('Please try again.');const before=await beforeResponse.json();
    const existing=(before.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code);
    const response=await fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:[...new Set([...existing,code])].join(','),sections:[drawer.dataset.sectionId,'cart-icon-bubble'],sections_url:location.pathname})});
    const data=await response.json();if(!response.ok)throw new Error(data.description || 'Please try again.');
    const valid=data.discount_codes?.some(d=>d.code.toUpperCase()===code && d.applicable);
    if(!valid){
     const automatic=(data.cart_level_discount_applications||[]).some(entry=>(entry.discount_application||entry).type==='automatic');
     say(code==='FIRSTORDER' && automatic ? 'Your bundle discount is active. FIRSTORDER cannot currently be combined with it.' : form.dataset.invalid);return;
    }
    save();drawer.renderContents(data);
    const fresh=drawer.querySelector('[data-coupon-form]');if(fresh){fresh.elements.coupon.value=code;const message=fresh.querySelector('[data-coupon-status]');message.textContent=code+' — '+form.dataset.applied;message.dataset.success='true';message.hidden=false;}
    this.celebrate(drawer);
   }catch(error){say(error.message);}finally{this.busy=false;this.querySelectorAll('button').forEach(b=>b.disabled=false);}
  };
  onClick = async (event) => {
   const button=event.target.closest('button'); if(!button || this.busy) return;
   if(button.hasAttribute('data-apply-code')) {
    const form=button.closest('[data-coupon-form]');form.elements.coupon.value=button.dataset.applyCode;form.requestSubmit();return;
   }
   if(button.hasAttribute('data-checkout')) {
    if(typeof window.HeadlessCheckout?.checkout !== 'function'){this.error('Checkout is still loading. Please try again in a moment.');return;}
    window.HeadlessCheckout.checkout(); return;
   }
   if(!button.hasAttribute('data-add') && !button.hasAttribute('data-key')) return;
   this.busy=true; this.querySelectorAll('button').forEach(b=>b.disabled=true);
   const drawer=this.closest('cart-drawer');
   const root=window.Shopify?.routes?.root || '/';
   const body={sections:[drawer.dataset.sectionId,'cart-icon-bubble'],sections_url:location.pathname};
   const adding=button.hasAttribute('data-add');
   if(adding) body.items=[{id:Number(button.dataset.add),quantity:1}];
   else {body.id=button.dataset.key;body.quantity=Number(button.dataset.quantity);}
   try {
    const response=await fetch(root+'cart/'+(adding?'add':'change')+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const data=await response.json(); if(!response.ok || data.status) throw new Error(data.description || 'Unable to update your cart. Please try again.');
    if(!data.sections?.[drawer.dataset.sectionId]) throw new Error('Your cart changed. Close and reopen it to refresh.');
    drawer.renderContents(data);
   } catch(error){this.error(error.message);}
   finally {this.busy=false;this.querySelectorAll('button').forEach(b=>b.disabled=false);}
  };
  error(message){const target=this.querySelector('.ms-cart-error');if(target){target.textContent=message;target.hidden=false;}}
 }
 customElements.define('ms-cart-content',MaxSmileCart);
 document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches('.ms-product-card__actions form')) return;
  const drawer=document.querySelector('cart-drawer.ms-cart');if(!drawer?.addItems) return;
  event.preventDefault();
  const button=form.querySelector('button');if(button.disabled)return;button.disabled=true;
  try { const data=new FormData(form);await drawer.addItems([{id:Number(data.get('id')),quantity:Number(data.get('quantity')||1)}],button); }
  catch(error) { let message=form.querySelector('[role="alert"]');if(!message){message=document.createElement('p');message.setAttribute('role','alert');form.append(message);}message.textContent=error.message; }
  finally {button.disabled=false;}
 });
})();
